import { ref as w, watch as S } from "vue";
import { storage as p } from "@gitcoffee/storage";
import { createI18n as M } from "vue-i18n";
import { defineStore as b } from "@gitcoffee/store";
const f = [
  {
    code: "zh",
    name: "Chinese",
    nativeName: "简体中文",
    antdLocalePath: "ant-design-vue/es/locale/zh_CN"
  },
  {
    code: "zh-TW",
    name: "Traditional Chinese",
    nativeName: "繁體中文",
    antdLocalePath: "ant-design-vue/es/locale/zh_TW"
  },
  {
    code: "en",
    name: "English",
    nativeName: "English",
    antdLocalePath: "ant-design-vue/es/locale/en_US"
  }
  // 后续添加新语言只需在这里添加配置
  // 例如：
  // {
  //   code: 'ja',
  //   name: 'Japanese',
  //   nativeName: '日本語',
  //   antdLocalePath: 'ant-design-vue/es/locale/ja_JP'
  // }
], L = {
  // 中文相关映射
  zh: "zh",
  "zh-CN": "zh",
  "zh-Hans": "zh",
  "zh-CHS": "zh",
  // 繁体中文相关映射
  "zh-TW": "zh-TW",
  "zh-Hant": "zh-TW",
  "zh-CHT": "zh-TW",
  // 英文相关映射
  en: "en",
  "en-US": "en",
  "en-GB": "en"
  // 后续添加新语言的映射
  // 'ja': 'ja',
  // 'ja-JP': 'ja'
}, $ = () => {
  let a = "";
  return typeof navigator < "u" && (a = navigator.language || navigator.userLanguage || ""), L[a] || L[a.split("-")[0]] || f[0].code;
}, B = (a) => {
  const e = f.find((n) => n.code === a);
  return e ? e.nativeName : a;
}, y = (a) => {
  if (L[a])
    return L[a];
  const e = a.split("-")[0];
  return L[e] || a;
}, K = (a) => a, O = () => f.map((a) => a.code), I = (a, e, n = {}) => {
  for (const t in e)
    if (e.hasOwnProperty(t)) {
      const o = e[t], g = a ? `${a}.${t}` : t;
      typeof o == "object" && o !== null && !Array.isArray(o) ? I(g, o, n) : n[g] = o;
    }
  return n;
}, E = (a) => {
  if (typeof window < "u")
    try {
      return localStorage.getItem(a);
    } catch (e) {
      console.error(`Error getting ${a} from localStorage:`, e);
    }
  return null;
}, A = (a, e) => {
  if (typeof window < "u")
    try {
      localStorage.setItem(a, e);
    } catch (n) {
      console.error(`Error setting ${a} to localStorage:`, n);
    }
}, T = (a) => a.toLowerCase(), F = (a) => T(a).split("-")[0], D = (a) => ["ar", "he", "fa", "ur"].includes(F(a)), s = {
  /**
   * 同步获取存储值
   */
  get: (a) => {
    console.log(`Getting ${a} from storage`);
    try {
      if (typeof window < "u" && window.localStorage) {
        console.log(`Using localStorage for ${a}`);
        const e = E(a);
        if (console.log(`Got ${a} from localStorage:`, e), e !== null)
          return e;
      }
      console.log(`No localStorage or no value for ${a}`);
    } catch (e) {
      console.error(`Error getting ${a} from storage:`, e);
    }
    return null;
  },
  /**
   * 异步获取存储值
   */
  getAsync: async (a) => {
    console.log(`Getting ${a} from async storage`);
    try {
      try {
        const e = await p.get(a);
        return console.log(`Got ${a} from async storage:`, e), e ?? null;
      } catch (e) {
        return console.warn("Error with @gitcoffee/storage, falling back to localStorage:", e), s.get(a);
      }
    } catch (e) {
      return console.error(`Error getting ${a} from async storage:`, e), s.get(a);
    }
  },
  /**
   * 同步设置存储值
   */
  set: (a, e) => {
    console.log(`Setting ${a} to storage:`, e);
    try {
      typeof window < "u" && window.localStorage && (console.log(`Using localStorage for ${a}`), A(a, e), console.log(`Set ${a} to localStorage successfully`));
    } catch (n) {
      console.error(`Error setting ${a} to storage:`, n);
    }
  },
  /**
   * 异步设置存储值
   */
  setAsync: async (a, e) => {
    console.log(`Setting ${a} to async storage:`, e);
    try {
      try {
        await p.set(a, e), console.log(`Set ${a} to async storage successfully`);
      } catch (n) {
        console.warn("Error with @gitcoffee/storage, falling back to localStorage:", n), s.set(a, e);
      }
    } catch (n) {
      console.error(`Error setting ${a} to async storage:`, n), s.set(a, e);
    }
  },
  /**
   * 移除存储值
   */
  remove: (a) => {
    console.log(`Removing ${a} from storage`);
    try {
      typeof window < "u" && window.localStorage && (localStorage.removeItem(a), console.log(`Removed ${a} from localStorage successfully`));
    } catch (e) {
      console.error(`Error removing ${a} from storage:`, e);
    }
  },
  /**
   * 异步移除存储值
   */
  removeAsync: async (a) => {
    console.log(`Removing ${a} from async storage`);
    try {
      try {
        await p.remove(a), console.log(`Removed ${a} from async storage successfully`);
      } catch (e) {
        console.warn("Error with @gitcoffee/storage, falling back to localStorage:", e), s.remove(a);
      }
    } catch (e) {
      console.error(`Error removing ${a} from async storage:`, e), s.remove(a);
    }
  }
};
class N {
  currentLanguage = w("zh");
  i18n = null;
  initialized = !1;
  languageChangeCallbacks = [];
  languageCodeMap = {
    // Chinese related mappings
    zh: "zh",
    "zh-CN": "zh",
    "zh-Hans": "zh",
    "zh-CHS": "zh",
    // Traditional Chinese mappings
    "zh-TW": "zh-TW",
    "zh-Hant": "zh-TW",
    "zh-CHT": "zh-TW",
    // English mappings
    en: "en",
    "en-US": "en",
    "en-GB": "en"
  };
  constructor() {
    S(this.currentLanguage, (e, n) => {
      console.log("Locale changed from:", n, "to:", e), this.handleLanguageChange(e);
    }, { immediate: !1 });
  }
  /**
   * 获取i18n实例
   */
  getI18n() {
    return this.i18n;
  }
  /**
   * 初始化语言设置
   */
  initLanguage(e) {
    if (console.log("Entering initLanguage method"), this.initialized) {
      console.log("Language already initialized, returning");
      return;
    }
    e && typeof e != "string" && "global" in e && (console.log("Setting i18n instance from parameter"), this.i18n = e, this.i18n.global.locale.value = this.currentLanguage.value);
    try {
      console.log("Getting saved locale from storage");
      const n = s.get("locale");
      if (n) {
        console.log("Found saved locale:", n);
        const t = this.mapLanguageCode(n);
        console.log("Mapped locale:", t), this.currentLanguage.value = t, this.i18n && (this.i18n.global.locale.value = t);
      } else {
        console.log("No saved locale found, using default");
        const t = "zh";
        this.currentLanguage.value = t, this.i18n && (this.i18n.global.locale.value = t);
      }
    } catch (n) {
      console.warn("Failed to get locale from storage, using default language:", n);
      const t = "zh";
      this.currentLanguage.value = t, this.i18n && (this.i18n.global.locale.value = t);
    }
    this.initialized = !0, console.log("Language initialization completed, current language:", this.currentLanguage.value);
  }
  /**
   * 设置i18n实例
   */
  setI18n(e) {
    this.i18n = e, this.i18n && (this.i18n.global.locale.value = this.currentLanguage.value);
  }
  /**
   * 注册语言变化回调函数
   */
  registerLanguageChangeCallback(e) {
    this.languageChangeCallbacks.includes(e) || this.languageChangeCallbacks.push(e);
  }
  /**
   * 取消注册语言变化回调函数
   */
  unregisterLanguageChangeCallback(e) {
    const n = this.languageChangeCallbacks.indexOf(e);
    n !== -1 && this.languageChangeCallbacks.splice(n, 1);
  }
  /**
   * 映射语言代码（将应用特定的语言代码转换为核心支持的语言代码）
   */
  mapLanguageCode(e) {
    return this.languageCodeMap[e] || e;
  }
  /**
   * 反向映射语言代码（将核心支持的语言代码转换为应用特定的语言代码）
   */
  reverseMapLanguageCode(e) {
    return e === "zh" ? "zh-CN" : e === "en" ? "en-US" : e;
  }
  /**
   * 处理语言变化
   */
  handleLanguageChange(e) {
    if (this.i18n)
      try {
        this.i18n.global.locale.value = e;
      } catch (n) {
        console.error("Error updating i18n locale:", n);
      }
    s.set("locale", e), this.languageChangeCallbacks.forEach((n) => {
      n(e);
    });
  }
  /**
   * 设置语言
   */
  setLanguage(e) {
    f.some(
      (t) => t.code === e
    ) ? (this.currentLanguage.value = e, this.handleLanguageChange(e)) : console.warn(`Unsupported language: ${e}`);
  }
  /**
   * 获取当前语言响应式引用
   */
  getCurrentLanguageRef() {
    return this.currentLanguage;
  }
  /**
   * 获取当前语言字符串值
   */
  getCurrentLanguage() {
    return this.currentLanguage.value;
  }
}
const r = new N(), j = () => r.getCurrentLanguageRef(), q = (a) => r.registerLanguageChangeCallback(a), J = (a) => r.unregisterLanguageChangeCallback(a);
class P {
  messages = {};
  constructor() {
    for (const e of f)
      this.messages[e.code] = {};
  }
  /**
   * 获取所有语言消息
   */
  getAllMessages() {
    return { ...this.messages };
  }
  /**
   * 获取特定语言的消息
   */
  getMessages(e) {
    return this.messages[e] || {};
  }
  /**
   * 注册项目特定的语言消息
   */
  registerProjectMessages(e, n, t) {
    if (typeof e == "string" && n && t) {
      const o = n, g = typeof t == "function" ? t() : t;
      this.registerSingleLanguageMessages(o, g);
    } else {
      const o = e, g = n;
      for (const i in o)
        o.hasOwnProperty(i) && this.registerSingleLanguageMessages(i, o[i], g);
    }
  }
  /**
   * 深度合并消息对象
   * @param target 目标对象
   * @param source 源对象
   */
  mergeMessages(e, n) {
    for (const t in n)
      if (n.hasOwnProperty(t)) {
        const o = n[t], g = e[t];
        typeof o == "object" && o !== null && !Array.isArray(o) ? ((!g || typeof g != "object") && (e[t] = {}), this.mergeMessages(e[t], o)) : e[t] = o;
      }
  }
  /**
   * 注册单语言的项目特定消息
   */
  registerSingleLanguageMessages(e, n, t) {
    this.messages[e] || (this.messages[e] = {});
    const o = (l, u = "") => {
      let m = {};
      for (const c in l)
        if (l.hasOwnProperty(c)) {
          const v = u ? `${u}.${c}` : c;
          typeof l[c] == "object" && l[c] !== null && !Array.isArray(l[c]) ? Object.assign(m, o(l[c], v)) : m[v] = l[c];
        }
      return m;
    }, g = o(n);
    this.mergeMessages(this.messages[e], g);
    const i = r.getI18n();
    if (i) {
      const l = this.getAllMessages();
      for (const u in l)
        l.hasOwnProperty(u) && i.global.setLocaleMessage(u, l[u]);
    }
  }
  /**
   * 异步获取语言设置（兼容接口）
   */
  getAsync(e) {
    return Promise.resolve(r.getCurrentLanguage());
  }
}
const h = new P(), Q = (a, e, n) => h.registerProjectMessages(a, e, n), X = (a, e, n) => h.registerSingleLanguageMessages(a, e, n), Y = () => h.getAllMessages(), Z = (a) => h.getMessages(a);
let d = null;
const C = (a) => {
  if (d)
    return d;
  const e = h.getAllMessages(), n = {
    locale: r.getCurrentLanguage(),
    fallbackLocale: "zh",
    // 使用中文作为回退语言
    messages: e,
    legacy: !1,
    // 使用 Composition API
    globalInjection: !0,
    // 全局注入 $t 函数
    messageFormat: "basic",
    // 使用基本消息格式，避免使用 eval() 或 new Function()
    missing: (t, o) => (console.warn(`Missing translation for key: ${o} in locale: ${t}`), o),
    ...a
  };
  return d = M(n), r.setI18n(d), d;
}, k = (a, e) => {
  const n = r.getI18n();
  return n ? n.global.t(a, e) : a;
}, W = () => (a, e) => {
  const n = r.getI18n();
  return n ? n.global.t(a, e) : a;
}, ee = (a) => h.getAsync("locale").then((e) => {
  if (e && a) {
    const n = e;
    n !== a.global.locale.value && (a.global.locale.value = n, r.setLanguage(n));
  }
}).catch((e) => {
  console.error("Failed to update i18n locale:", e);
}), ae = () => ({ t: W() }), ne = b("i18n", {
  state: () => ({
    currentLanguage: "zh",
    initialized: !1,
    i18n: null
  }),
  getters: {
    /**
     * 获取当前语言
     */
    getCurrentLanguage: (a) => a.currentLanguage
  },
  actions: {
    /**
     * 初始化语言设置
     */
    async initLanguage() {
      const a = this;
      if (!a.initialized) {
        try {
          const e = await s.getAsync("locale");
          e && (a.currentLanguage = e);
        } catch (e) {
          console.error("Failed to get locale from storage:", e);
        }
        a.initialized = !0;
      }
    },
    /**
     * 设置语言
     */
    setLanguage(a) {
      const e = this;
      f.some(
        (t) => t.code === a
      ) ? (e.currentLanguage = a, s.set("locale", a), e.i18n && (e.i18n.global.locale.value = a), r.setLanguage(a)) : console.warn(`Unsupported language: ${a}`);
    },
    /**
     * 设置i18n实例
     */
    setI18n(a) {
      const e = this;
      e.i18n = a, e.i18n && (e.i18n.global.locale.value = e.currentLanguage), r.setI18n(a);
    }
  }
}), te = () => r.getCurrentLanguage(), oe = (a) => r.setLanguage(a), re = (a) => r.setI18n(a), se = () => r.getI18n(), U = () => r.initLanguage(), G = () => {
  const a = s.get("locale");
  return a ? y(a) : $();
}, ge = async () => {
  try {
    const a = await s.getAsync("locale");
    if (a)
      return y(a);
  } catch (a) {
    console.error("Failed to get locale from storage:", a);
  }
  return G();
}, H = (a) => s.getAsync("locale").then((e) => {
  if (e && a) {
    const n = y(e);
    n !== a.global.locale.value && (a.global.locale.value = n, r.setLanguage(n));
  }
}).catch((e) => {
  console.error("Failed to update locale from storage:", e);
});
let z = !1;
const le = async (a) => {
  if (console.log("Entering initI18n function"), z) {
    console.log("i18n already initialized, checking for existing instance");
    const e = r.getI18n();
    return e ? (console.log("Returning existing i18n instance"), e) : (console.log("No existing i18n instance, creating a new one"), C(a));
  }
  try {
    console.log("Initializing language settings"), U(), console.log("Creating i18n instance");
    const e = C(a);
    console.log("i18n instance created successfully:", e);
    try {
      console.log("Updating locale from storage"), await H(e), console.log("Locale updated from storage successfully");
    } catch (n) {
      console.warn("Failed to update locale from storage, using default language:", n), r.setLanguage("zh");
    }
    return z = !0, console.log("i18n initialization completed successfully"), e;
  } catch (e) {
    console.error("Failed to initialize i18n:", e);
    const n = C({
      ...a,
      locale: "zh",
      fallbackLocale: "zh"
    });
    return z = !0, n;
  }
};
export {
  k as $t,
  C as createI18nInstance,
  I as flattenMessages,
  Y as getAllMessages,
  te as getCurrentLanguage,
  $ as getDefaultLanguage,
  se as getI18n,
  B as getLanguageName,
  ge as getLocaleAsync,
  G as getLocaleSync,
  F as getMainLanguageCode,
  Z as getMessages,
  O as getSupportedLanguageCodes,
  U as initCoreLanguage,
  le as initI18n,
  U as initLanguage,
  D as isRTL,
  L as languageCodeMap,
  r as localeManager,
  h as localeMessagesManager,
  y as mapLanguageCode,
  T as normalizeLanguageCode,
  q as registerLanguageChangeCallback,
  X as registerLanguageMessages,
  Q as registerProjectMessages,
  K as reverseMapLanguageCode,
  E as safeGetFromLocalStorage,
  A as safeSetToLocalStorage,
  re as setCoreI18n,
  oe as setCoreLanguage,
  oe as setCurrentLanguage,
  re as setI18n,
  oe as setLanguage,
  f as supportedLanguages,
  s as supportedStorage,
  k as t,
  J as unregisterLanguageChangeCallback,
  ee as updateI18nLocale,
  H as updateLocaleFromStorage,
  ee as updateLocaleFromStorageAsync,
  j as useCurrentLanguage,
  ae as useI18n,
  W as useI18nCore,
  ne as useI18nStore,
  W as useTranslate,
  ae as useVueI18n
};
//# sourceMappingURL=index.mjs.map
